import React, { useState, useEffect } from 'react';
import {
  Button,
  IconButton,
  Typography,
  Grid,
  Box
} from "@mui/material";
import { useSnackbar } from 'notistack';
import { ACTIONS, MESSAGES } from '../../../shared/constants';
import DataTable from '../../../shared/data-table';
import {
  saveAllNewsletterTargets,
  saveRegisterActivity,
  getAllActivityCampaign,
  getSelectedNewsletter,
  getAllNewsletterStates,
  getAllCustomers,
  getAllNewsletterTypes,
  getAllEmployeePositions,
  getAllAirports,
  getResportStateData,
  getListAssessment,
  getAllNewsLetterContentTypes,
  getAssessmentReportByNewsletterIdData,
} from './logic';
import RegisterCampaingSource from '../register-campaing-detail/register-campaing-source';
import NewsletterStateReport from '../newsletter-state-report';
import NewsletterAssessmentReport from '../newsletter-assessment-report';
import Edit from '@mui/icons-material/Edit';
import AddCircle from '@mui/icons-material/AddCircle';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import { FormatDateToStringComplete } from '../../../shared/functions';
import ErrorSnackbar from '../../error-snackbar';
import BackDrop from '../../../shared/backdropDE';
import { getUser } from '../../../shared/auth-service';
import { QrCodeScanner } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';

const RegisterCampaing = () => {
  const user = getUser();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [activityId, setActivityId] = useState(null);
  const [reportData, setReportData] = useState(null);
  const [id, setId] = useState(null);
  const [newsletterId, setNewsletterId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModalSource, setShowModalSource] = useState(null);
  const [showModalQRScanner, setshowModalQRScanner] = useState(null);
  const [showModalAssessment, setShowModalAssessment] = useState(null);
  const [action, setAction] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [newsletterStates, setNewsletterStates] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [newsletterTypes, setNewsletterTypes] = useState([]);
  const [employeePositions, setEmployeePositions] = useState([]);
  const [airports, setAirports] = useState([]);
  const [name, setName] = useState(null);
  const [error, setError] = useState(null);
  const [assessments, setAssessments ] = useState([]);
  const [newsLetterContentTypes, setNewsLetterContentTypes ] = useState([]);
  const [onlyEnabledCustomerEmployees, setOnlyEnabledCustomerEmployees ] = useState(false);
  const companyId = user.countryCode.split('-')[0];
  const company = user.countryCode.split('-')[1];
  const personResponsibleId = user.employeeId;

  useEffect(() => {
    async function fetchData() {
      if (loading) {
        try {
          const data = await getAllActivityCampaign(user.employeeId, companyId);
          const newsletterStatesData = await getAllNewsletterStates();
          const customersData = await getAllCustomers(companyId);
          const newsletterTypesData = await getAllNewsletterTypes(companyId);
          const employeePositionsData = await getAllEmployeePositions(companyId);
          const airportsData = await getAllAirports(companyId);
          const assessmentData  = await getListAssessment(companyId);
          const newsLetterContentTypesData = await getAllNewsLetterContentTypes();
          setNewsLetterContentTypes(newsLetterContentTypesData); 
          setAssessments(assessmentData); 
          setEmployeePositions(employeePositionsData);
          setNewsletterStates(newsletterStatesData);
          setCustomers(customersData);
          setNewsletterTypes(newsletterTypesData);
          setAirports(airportsData);
          setData(data);
          setLoading(false);
        } catch (error) {
          setError(error.message);
          setLoading(false);
        }
      }
    }
    fetchData();
  });

  useEffect(() => {
    async function fetchRow() {
      if (id) {
        if (action === ACTIONS.VIEW_STATE) {
          const data = await getResportStateData(id);
          setReportData(data);
          setshowModalQRScanner(true);
          setId(null);
          return;
        }
        
        if (action === ACTIONS.VIEW_ASSESSMENT_STATE) {
          const data = await getAssessmentReportByNewsletterIdData(id);
          setReportData(data);
          setId(null);
          setShowModalAssessment(true);
          return;
        }

        if (action == ACTIONS.VIEW_STATE || action === ACTIONS.EDIT_SOURCES) {
          const item = await getSelectedNewsletter(id);
          //console.log('esta es la data')
          //console.log(item);
          setOnlyEnabledCustomerEmployees(item.onlyEnabledCustomerEmployees);
          setSelectedItem(item);
          setId(null);
          if (action === ACTIONS.EDIT_SOURCES) {
            setShowModalSource(true);
          }
          return;
        }
        if (action == ACTIONS.VIEW_ASSESSMENT_STATE) {
          const data = await getResportStateData(id);
          setReportData(data);
          setId(null);
          setShowModalAssessment(true);
          return;
        }
      }
    }
    fetchRow();
  });


  const handleSaveSources = async (
    employeeId
  ) => {

    const response = await saveRegisterActivity(employeeId, activityId, personResponsibleId);
    
     // Manejar el mensaje basado en la respuesta
     if (response && response.data.statusCode === 0) {
      enqueueSnackbar(response.data.message, { variant: 'success' });
      //setShowModalSource(false);
      //setLoading(true);
    } else if (response && response.data.statusCode === 1) {
      enqueueSnackbar(response.data.message, { variant: 'warning' });
    } else if (response && response.data.statusCode === 2) {
      enqueueSnackbar(response.data.message, { variant: 'info' });
    } else {
      enqueueSnackbar('Error desconocido al guardar el registro.', { variant: 'error' });
      setShowModalSource(false);
      setLoading(true);
    }
    
    //enqueueSnackbar(MESSAGES.SAVED);
  };

  const handleNew = async () => {
    setSelectedItem({});
    setId(null);
    setShowModalSource(true);
  };

  const handleCloseQRScanner = () => {
    setshowModalQRScanner(false);
  };

  const handleActionButton = (e, cellValues, action) => {
    e.stopPropagation();
    setId(cellValues.row.activityId);
    setActivityId(cellValues.row.activityId);
    setNewsletterId(cellValues.row.id);
    setName(cellValues.row.name);
    setAction(action);
  };

  const columns = [
    {
      field: "ScanQR",
      headerName: "QR",
      width: 70,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      toolTip: 'Registro de Asistencia',
      renderCell: (cellValues) => {
        const isDisabled = cellValues.row.campaignState !== 'ACTIVA'; // Cambia según tu lógica
        const tooltipText = isDisabled 
          ? "La campaña no está activa. No se puede registrar." 
          : "Registrar asistencia";
  
        return (
          <Tooltip title={tooltipText} arrow>
            <span> {/* Necesario para que el Tooltip funcione con botones deshabilitados */}
              <IconButton
                color="info"
                onClick={(e) => { handleActionButton(e, cellValues, ACTIONS.VIEW_STATE) }}
                disabled={isDisabled} // Deshabilitar dinámicamente
              >
                <QrCodeScanner />
              </IconButton>
            </span>
          </Tooltip>
        );
      }
    },
    { field: 'activityId', headerName: 'Id', width: 50, headerAlign: 'center', align:'center' },
    { field: 'campaignId', headerName: 'CampaignId', width: 50, hide: true},
    { field: 'campaignName', headerName: 'Campaña', width: 350 },
    { field: 'activityName', headerName: 'Actividad', width: 280 },
    {
      field: 'startDate', headerName: 'Fecha Desde', headerAlign: 'center', align:'center',
      renderCell: (cellValues) => {
        return cellValues.value ? FormatDateToStringComplete(cellValues.value) : null;
      }, width: 110
    },
    {
      field: 'endDate', headerName: 'Fecha Hasta', headerAlign: 'center', align:'center',
      renderCell: (cellValues) => {
        return cellValues.value ? FormatDateToStringComplete(cellValues.value) : null;
      }, width: 110
    },
    {
      field: 'customerName', headerName: 'Emisor/Cliente', headerAlign: 'center', align:'center',
      renderCell: (cellValues) => {
        return cellValues.value ? cellValues.value.name : null;
      }, width: 250
    },
    {
      field: 'campaignState', headerName: 'Estado', headerAlign: 'center', align:'center',
      renderCell: (cellValues) => {
        return cellValues.value ? cellValues.value.name : null;
      }, width: 120
    },
  ];

  if (loading) {
    return (
      // <Box sx={{ display: 'flex' }}>
      //     <CircularProgress />
      // </Box>
      <BackDrop />
    );
  }

  if (error) {
    return (<ErrorSnackbar message={error} />);
  }

  return (
    <>
      {showModalQRScanner && <RegisterCampaingSource
        isOpen={showModalQRScanner}
        onClose={handleCloseQRScanner}
        handleSaveSources={handleSaveSources}
      />}
      {error && <ErrorSnackbar message={error} />

      }
      <Grid container spacing={2}>
        <Grid item xs={10}>
          <Typography variant="h5" style={{ color: '#1a3072' }} fontWeight="bold" sx={{ flexGrow: 1, m: 1, }}>
            Registro Campañas
          </Typography>
          {/* <Typography variant="h5" gutterBottom>
                {`${TITLES.NEWSLETTER}`}
              </Typography> */}
        </Grid>
      </Grid>
      <DataTable
        columns={columns}
        getRowId={(row) => row.activityId}
        rows={data || []}
        style={{ maxWidth: '100%', overflow: 'auto'}}

        sx={{
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold', // Aplicar negrita a los títulos de las columnas
          }
        }}
      />
    </>
  );
};

export default RegisterCampaing;